import axios from "axios";
import React, { useEffect, useState, useCallback } from "react";
import { Link, useParams } from "react-router-dom";
import { BACKEND } from "../config/configEnvs";
import { FaBolt, FaCheck, FaChevronRight, FaClipboardList, FaClock, FaPowerOff, FaRegEye, FaSpinner, FaTimes } from "react-icons/fa";
import Draggable from "../components/ui/Dragable";
import ItemRowSeguimientoClienteDetails from "../components/seguimiento/ItemRowSeguimientoClienteDetails";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Tooltip from "../components/ui/ToolTip";
import { MdSchedule } from "react-icons/md";

const SeguimientoClienteDetails = () => {
    const { id } = useParams();
    const [client, setClient] = useState({})
    const [services, setServices] = useState([])
    const [activeFilter, setActiveFilter] = useState(true)

    const user = useSelector((state) => state.auth.user)

    // Pedir los datos del cliente
    const fetchClient = async () => {
        const response = await axios.get(`${BACKEND}/api/clientesUser/${id}`);
        setClient(response.data)
    }

    // Se piden los servicios del cliente según los permisos del usuario al custom endpoint
    const fetchClientServicesByUser = async () => {
        try {
            const response = await axios.get(`${BACKEND}/api/userProcessesInterface/getServices?userId=${user.id}&brandId=${id}`)
            setServices(response.data.services)
        } catch (error) {
            console.log(error)
            toast.error("Error obteniendo los servicios del cliente: " + error)
        }
    }

    // Filtro para solo mostrar los servicios activos
    const activeFilterHandler = () => {
        setActiveFilter(prevState => !prevState);
    }

    function capitalizeWords(str) {
        if (!str) return ''; // Verifica si la cadena es undefined o null, y devuelve una cadena vacía
        return str
          .split(' ') // Divide la cadena en palabras separadas por espacios
          .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitaliza la primera letra y convierte el resto en minúsculas
          .join(' '); // Vuelve a unir las palabras en una sola cadena
    }

    useEffect(() => {
        fetchClientServicesByUser()
        fetchClient()
    }, [])

    
    // Filtrar servicios según el activeFilter
    const filteredServices = activeFilter
        ? services.filter(service => service.activeCount > 0 || service.toStartCount > 0)
        : services;

    return (
        <div>
            <div className="flex flex-row px-4 py-2 overflow-x-auto bg-gray-100 mb-2">
                <div className="flex flex-row w-full items-center gap-4 justify-between">
                    <div className="flex items-center gap-4 py-4">
                        <FaClipboardList className="text-zinc-700 text-2xl" />
                        <Link to={'/home/seguimiento'}>
                            <h2 className="text-2xl font-bold text-zinc-700 hover:text-orange-500 transition-all duration-200">
                                Seguimiento de proyectos
                            </h2>
                        </Link>
                        <FaChevronRight className="text-orange-500 text-2xl" />
                        <h2 className="text-2xl font-bold text-zinc-700 hover:text-orange-500 transition-all duration-200">
                            {capitalizeWords(client.nombreComercial)}
                        </h2>
                    </div>
                </div>
            </div>

            <div className="flex items-center justify-center bg-gray-100 gap-3 mb-2 py-2 px-4 rounded-sm">
                <span className="text-gray-700 text-xs font-medium">Mostrar solo servicios activos o por comenzar</span>
                <label className="relative inline-flex items-center cursor-pointer">
                    <input
                        id="activeFilter"
                        type="checkbox"
                        checked={activeFilter}
                        onChange={activeFilterHandler}
                        className="sr-only peer"
                    />
                    <div className="w-11 h-6 bg-gray-200 rounded-full peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 peer-dark:bg-gray-700 peer-checked:bg-blue-600 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:bg-white after:border-gray-300 after:border after:rounded-full after:w-5 after:h-5 after:transition-all dark:border-gray-600"></div>
                </label>
            </div>

            <Draggable showMiniMap={false}>
                <div className="overflow-y-auto overflow-x-auto w-full mx-auto pb-4 h-[80vh] border-b">
                    <table className="w-full relative text-sm text-left text-gray-500">
                        <thead className="text-xs sticky top-0 z-20 text-gray-900 uppercase bg-gray-200">
                            <tr>
                                <th scope="col" className="px-6 py-3">Estado</th>
                                <th scope="col" className="px-6 py-3 text-center">Servicio</th>
                                <th scope="col" className="px-6 py-3 text-center">N° de servicios contratados</th>
                                <th scope="col" className="px-6 py-3 text-center">N° de servicios en proceso</th>
                                <th scope="col" className="px-6 py-3 text-center">N° de servicios por comenzar</th>
                                <th scope="col" className="px-6 py-3 text-center">N° de servicios termiandos con éxito</th>
                                <th scope="col" className="px-6 py-3 text-center">N° de servicios inactivos</th>
                                {/* <th scope="col" className="px-6 py-3">Ultima modificación</th> */}
                            </tr>
                        </thead>
                        <tbody className="">
                            {services.length === 0 ? (
                                <tr>
                                    <td colSpan="7" className="py-3 px-3 text-center">
                                        {services.length === 0 ? (
                                            <div className="flex flex-row justify-center items-center h-[70vh] gap-4">
                                                <FaSpinner className="animate-spin text-gray-500" />
                                                <span className="text-gray-600">Cargando, por favor espera...</span>
                                            </div>
                                        ) : (
                                            "La marca no ha contratado ningún servicio"
                                        )}
                                    </td>
                                </tr>
                            ) : filteredServices.length === 0 ? (
                                <tr>
                                    <td colSpan="7" className="py-3 px-3 text-center h-[60vh]">
                                        {activeFilter ? (
                                            "No hay servicios que coincidan con el filtro."
                                        ) : (
                                            "La marca no ha contratado ningún servicio."
                                        )}
                                    </td>
                                </tr>
                            ) : (

                                filteredServices.map((service) => (
                                    <tr className="bg-white text-xs border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 transition-all duration-100">
                                        <td scope="row" className="px-6 py-4">
                                            <div className="flex justify-start items-center gap-2">
                                                {service.activeCount > 0 && (
                                                    <>
                                                        <Tooltip content={`La empresa tiene ${service.activeCount} servicio(s) de ${service.name} en proceso`}>
                                                            <div className="hover:cursor-pointer">
                                                                <FaCheck className="text-green-500" />
                                                            </div>
                                                        </Tooltip>
                                                    </>
                                                 )}

                                                {service.toStartCount > 0 && (
                                                    <>
                                                        <Tooltip content={`La empresa tiene ${service.toStartCount} servicio(s) de ${service.name} por comenzar`}>
                                                            <div className="hover:cursor-pointer">
                                                                <MdSchedule className="text-yellow-500" />
                                                            </div>
                                                        </Tooltip>
                                                    </>
                                                )}
                                                  
                                                { service.toStartCount === 0 && service.activeCount === 0 && (
                                                    <>
                                                        <Tooltip content={`La empresa no tiene servicios de "${service.name}" en proceso`}>
                                                            <div className="hover:cursor-pointer">
                                                                <FaTimes className="text-red-900" />
                                                            </div>
                                                        </Tooltip> 
                                                    </>
                                                )}

                                                <Link to={`/home/seguimiento/${client.id}/${service.name}`}>
                                                    <div className="p-2 text-blue-500 hover:bg-blue-600 hover:bg-opacity-25 rounded-md bg-blue-700 bg-opacity-10">
                                                    <FaRegEye className=" " />
                                                    </div>
                                                </Link>
                                            </div>
                                        </td>

                                        <td scope="col" className="px-6 py-3 text-center"> 
                                            {service.name} 
                                        </td>

                                        <td scope="col" className="px-6 py-3 text-center"> 
                                            {service.totalCount} 
                                        </td>

                                        <td scope="col" className="px-6 py-3 text-center"> 
                                            {service.activeCount} 
                                        </td>

                                        <td scope="col" className="px-6 py-3 text-center"> 
                                            {service.toStartCount} 
                                        </td>

                                        <td scope="col" className="px-6 py-3 text-center"> 
                                            {service.successCount} 
                                        </td>

                                        <td scope="col" className="px-6 py-3 text-center"> 
                                            {service.inactiveCount} 
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </Draggable>

        </div>
    )
}

export default SeguimientoClienteDetails